import { Shadow, HStack, VStack, Skeleton } from '@genial/components';
import { BoxRadius, Spacing } from '@genial/design-tokens';

/**
 * Creates a loading table with specified number of rows and columns.
 * @param numRows The number of rows in the table.
 * @param numCols The number of columns in the table.
 * @returns The loading table component.
 */
export const makeLoadingTable = ({
  numRows = 3,
  numCols = 6,
}: {
  numRows: number;
  numCols: number;
}) => {
  return (
    <VStack space={Spacing['stack.nano']}>
      {Array.from({ length: numRows }).map((_, n) => (
        <Shadow key={n} testId="shadow" level={1} borderRadius={BoxRadius.sm}>
          <HStack p={Spacing['inset.xs']} justifyContent="space-between">
            {Array.from({ length: numCols }).map((__, m) => (
              <Skeleton key={m.toString()} width={`${100 / 9}%`} height="14px" rounded="full" />
            ))}
          </HStack>
        </Shadow>
      ))}
    </VStack>
  );
};
